import gql from 'graphql-tag';

export const CREATE_STOCK_DELIVERY = gql`
    mutation createStockDeliveryMutation ($input: CreateStockDeliveryInput!) {
        createStockDelivery(input: $input) {
            id
        }
    }
`;

export const CREATE_STOCK_DELIVERY_WITH_ITEMS = gql`
	mutation createStockDeliveryWithItems (
		$purchaseOrderItems: JSON!,
		$purchaseOrder: ID!,
	) {
		createStockDeliveryWithItems (
			purchaseOrderItems: $purchaseOrderItems,
			purchaseOrder: $purchaseOrder,
		) {
			id
		}
	}
`;
